import console from './console'
import localstorage from './localstorage'

export default {
  console,
  localstorage
}



// WEBPACK FOOTER //
// ./src/appenders/index.js